import React, { useState, useEffect } from "react";
import "../assets/css/collegedetail.css";
import Footer from './footer';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa";
import axios from "axios";
import configModule from "../../config";
import { toast, ToastContainer } from "react-toastify";
import { MutatingDots } from "react-loader-spinner";
import SvgContent from "../components/Svgcontent";
import MapComponent from "../components/googlemap";
import ApplyNow from "./popups/applynow";
import NotFound from "./notfound";
import { decode } from "he";

const CollegeDetail = () => {
    const navigate = useNavigate();
    const config = configModule.config();
    const [activeTab, setActiveTab] = useState("overview");
    const [loading, setLoading] = useState(true);
    const [collegeCourses, setCollegeCourses] = useState([]);
    const [eligibilityAd, setEligibilityAd] = useState([]);
    const [collegeNewData, setCollegeNewData] = useState("");
    const [facultyDetails, setFacultyDetails] = useState([]);
    const [reviewsDetails, setReviewsDetails] = useState([]);
    const [collegeSecDetails, setCollegeSecDetails] = useState([]);
    const [picGallery, setPicGallery] = useState([]);
    const [recruiters, setRecruiters] = useState([]);
    const [coursesData, setCoursesData] = useState([]);
    const [picGalleryCount, setPicGalleryCount] = useState(0);
    const [open, setOpen] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [showAddressPopup, setShowAddressPopup] = useState(false);
    const pathname = window.location.pathname;

    const basePath = pathname.split('/').slice(0, 2).join('/');

    const currentUrl = `${window.location.origin}${basePath}`;

    const [formData, setFormData] = useState({
        lead_name: "",
        lead_email: "",
        lead_mobile: "",
        lead_clg_name: ""
    });

    const location = useLocation();
    const { id } = useParams();

    const [collegeDetails, setCollegeDetails] = useState(location.state || {});

    if (isNaN(id)) {
        return <NotFound />;
    }

    const facilities_data = Array.isArray(collegeDetails?.facilities)
        ? collegeDetails.facilities
        : JSON.parse(collegeDetails?.facilities || "[]");

    const getCollegeDetails = async () => {
        setLoading(true);

        const params = {
            college_id: id || -1
        };

        try {
            const res = await axios.get(
                `${config.apiBaseUrl}/get-colleges-details`, {
                params: params,
                headers: {
                    "x-api-key": config?.apichKey
                },
            }
            );

            const data = res?.data || "";
            const pgCount = data?.pgallery
                ? (() => {
                    const length = data.pgallery.length;
                    if (length > 10) return "10+";
                    if (length > 5) return "5+";
                    return "1+";
                })()
                : 0;
            const courses = data?.course ? data?.course.split(",") : [];

            setPicGalleryCount(pgCount);
            setCollegeCourses(courses);

            let recruiters = data?.recruiter_data;

            if (typeof recruiters === "string") {
                try {
                    recruiters = JSON.parse(recruiters);
                } catch {
                    recruiters = [];
                }
            }

            setRecruiters(Array.isArray(recruiters) ? recruiters : []);

            setCollegeNewData(data);


            let faculty = data?.faculty_data;

            if (typeof faculty === "string") {
                try {
                    faculty = JSON.parse(faculty);
                } catch {
                    faculty = [];
                }
            }

            setFacultyDetails(Array.isArray(faculty) ? faculty : []);


            let reviews = data?.reviews;

            if (typeof reviews === "string") {
                try {
                    reviews = JSON.parse(reviews);
                } catch {
                    reviews = [];
                }
            }
            setReviewsDetails(Array.isArray(reviews) ? reviews : []);

            let eligibility = data?.eligibility;

            if (typeof eligibility === "string") {
                try {
                    eligibility = JSON.parse(eligibility);
                } catch {
                    eligibility = [];
                }
            }
            setEligibilityAd(Array.isArray(eligibility) || []);

            let pgallery = data?.pgallery;

            if (typeof pgallery === "string") {
                try {
                    pgallery = JSON.parse(pgallery);
                } catch {
                    pgallery = [];
                }
            }
            setPicGallery(Array.isArray(pgallery) || []);


            setCollegeSecDetails(data || []);

        } catch (err) {
            console.error("API Error:", err);

            if (err.response) {
                toast.error(err.response.data?.message || "Server error");
            } else if (err.request) {
                toast.error("No response from server");
            } else {
                toast.error("Request failed");
            }

        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            if (location.state) {
                setCollegeDetails(location.state);
                setLoading(false);
            }

            getCollegeDetails();
        }
    }, [id]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    useEffect(() => {
        setTimeout(() => {
            document
                .getElementById("college-top")
                ?.scrollIntoView({ behavior: "smooth" });
        }, 50);
    }, [activeTab]);

    function decodeHTML(html) {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    };

    function cleanHTML(html) {
        return html.replace(/<\/?p>/g, "");
    }

    const onCloseHandler = () => {
        setOpen(false);
    };

    const getCourseDetails = async () => {
        const params = {
            college_id: collegeDetails?.id || -1,
            course_id: collegeSecDetails?.course_id || -1
        };

        try {
            const res = await axios.get(
                `${config.apiBaseUrl}/get-coursedetails`, {
                params: params,
                headers: {
                    "x-api-key": config?.apichKey
                },
            }
            );

            const data = res?.data || "";
            setCoursesData(data);
            setActiveTab("courses");


        } catch (err) {
            console.error("API Error:", err);

            if (err.response) {
                toast.error(err.response.data?.message || "Server error");
            } else if (err.request) {
                toast.error("No response from server");
            } else {
                toast.error("Request failed");
            }

        }
    };

    const renderStars = (rating) => {
        const stars = [];
        const fullStars = Math.floor(rating);
        const hasHalfStar = rating % 1 >= 0.1;

        for (let i = 0; i < fullStars; i++) {
            stars.push(<SvgContent key={`full-${i}`} svg_name="full_star" width="12" height="12" />);
        }

        if (hasHalfStar) {
            stars.push(<SvgContent key="half-star" svg_name="half_star" width="12" height="12" />);
        }

        const remaining = 5 - stars.length;

        for (let i = 0; i < remaining; i++) {
            stars.push(<SvgContent key={`empty-${i}`} svg_name="star" width="12" height="12" />);
        }

        return stars;
    };

    const getInitials = (name) => {
        return name
            .trim()
            .split(/\s+/)
            .map(word => word[0])
            .slice(0, 2)
            .join('')
            .toUpperCase();
    };

    const handleAddressLeadSubmit = async (e) => {
        e.preventDefault();
        setIsSubmit(true);
        try {

            const payload = {
                lead_name: formData.lead_name,
                lead_email: formData.lead_email,
                lead_mobile: formData.lead_mobile,
                lead_clg_name: collegeDetails?.name
            };

            const response = await axios.post(
                `${config.apiBaseUrl}/address-lead`,
                payload,
                {
                    headers: {
                        "x-api-key": config.apichKey
                    }
                }
            );

            if (response.data.success) {
                toast.success(response.data.message);
                setOpen(false);
                setIsSubmit(false);
                setShowAddressPopup(false);

                setFormData({
                    lead_name: "",
                    lead_email: "",
                    lead_mobile: "",
                    lead_clg_name: ""
                });
            }

        } catch (error) {
            toast.error(
                error.response?.data?.message ||
                "Submission failed"
            );
        }
    };

    return (
        <div className="mainnav-container h-auto" id="college-top" style={{ background: "F5FBFB" }}>
            <ToastContainer />
            {loading && (
                <div className="loader">
                    <MutatingDots
                        height="100"
                        width="100"
                        color="#35e2e9"
                        secondaryColor="#FF9800"
                        radius="15"
                        ariaLabel="mutating-dots-loading"
                        visible={true}
                    />
                </div>
            )}

            {showAddressPopup && (
                <div
                    className="al_popup_overlay"
                >
                    <div
                        className="al_popup_container"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className="al_close_btn"
                            onClick={() => setShowAddressPopup(false)}
                        >
                            ✕
                        </button>

                        <h2 className="al_popup_title">
                            Please fillup the details to get college address
                        </h2>

                        <form onSubmit={handleAddressLeadSubmit}>
                            <input
                                type="text"
                                name="lead_name"
                                placeholder="Name"
                                value={formData.lead_name}
                                onChange={handleChange}
                                className="al_input"
                                required
                            />

                            <input
                                type="email"
                                name="lead_email"
                                placeholder="Email"
                                value={formData.lead_email}
                                onChange={handleChange}
                                className="al_input"
                                required
                            />

                            <input
                                type="tel"
                                name="lead_mobile"
                                placeholder="Mobile"
                                value={formData.lead_mobile}
                                onChange={handleChange}
                                className="al_input"
                                required
                            />

                            <input
                                type="text"
                                name="lead_clg_name"
                                value={collegeDetails?.name}
                                className="al_input"
                                readOnly
                            />

                            <div className="al_btn_wrapper">
                                <button
                                    type="submit"
                                    className="al_submit_btn"
                                    disabled={isSubmit}
                                >
                                    {isSubmit ? "Submitting..." : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            <div className="cl-hero-banner">
                <div className="cl-hero-pattern"></div>
                <div className="cl-hero-text">
                    <h2>{decode(collegeDetails?.name)}</h2>
                    <p>{collegeDetails?.city}, {collegeDetails?.state} &nbsp;·&nbsp; ESTD. {collegeDetails?.established} &nbsp;·&nbsp; {collegeDetails?.university} Affiliated &nbsp;·&nbsp; {collegeDetails?.approved_by} Approved</p>
                </div>
                <span className="breadcrumb-st" > <span className="gotohome-st" onClick={() => navigate("/")} >Home</span> <FaAngleRight className="arrow_icon" /> <span className="gotohome-st" onClick={() => navigate("/college_listing")} >Colleges</span> <FaAngleRight className="arrow_icon" /> <b>{decode(collegeDetails?.name)}</b> </span>
            </div>

            <div className="profile-strip">
                <div className="profile-inner">
                    <div className="college-logo-box">
                        <img
                            src={collegeDetails?.college_primary_image}
                            alt="University"
                        />
                    </div>
                    <div className="profile-info">
                        <div className="profile-name">{decode(collegeDetails?.name)}</div>
                        <div className="profile-sub stylelist-st">
                            <div className="rating-badge"><i className="bi bi-star-fill"></i><span>{collegeDetails?.college_ranking} / 5</span></div>
                            <span className="info-chip"><i className="bi bi-geo-alt"></i> {collegeDetails?.city}, {collegeDetails?.state}</span>
                            <span className="info-chip"><i className="bi bi-mortarboard"></i> {collegeDetails?.university}</span>
                            <span className="info-chip"><i className="bi bi-patch-check"></i> {collegeDetails?.approved_by}</span>
                            <span className="info-chip"><i className="bi bi-calendar"></i> ESTD {collegeDetails?.established}</span>
                        </div>
                    </div>
                    <div className="profile-actions">
                        <button className="btn-primary" onClick={() => setOpen(true)}><i className="bi bi-send"></i> Apply Now</button>
                    </div>
                </div>

                <div className="mbstylelist-st">
                    <div className="rating-badge"><i className="bi bi-star-fill"></i><span>{collegeDetails?.college_ranking} / 5</span></div>
                    <span className="info-chip"><i className="bi bi-geo-alt"></i> {collegeDetails?.city}, {collegeDetails?.state}</span>
                    <span className="info-chip"><i className="bi bi-mortarboard"></i> {collegeDetails?.university}</span>
                    <span className="info-chip"><i className="bi bi-patch-check"></i> {collegeDetails?.approved_by}</span>
                    <span className="info-chip"><i className="bi bi-calendar"></i> ESTD {collegeDetails?.established}</span>
                </div>
            </div>

            <div className="coldet_container">

                <div className="coldet_tabs">
                    <div
                        className={`coldet_tab ${activeTab === "overview" ? "active" : ""}`}
                        onClick={() => setActiveTab("overview")}
                    >
                        <i className="bi bi-list"></i> OVERVIEW
                    </div>

                    <div
                        className={`coldet_tab ${activeTab === "courses" ? "active" : ""}`}
                        onClick={getCourseDetails}
                    >
                        <i className="bi bi-journals"></i>COURSES
                    </div>

                    <div
                        className={`coldet_tab ${activeTab === "facilities" ? "active" : ""}`}
                        onClick={() => setActiveTab("facilities")}
                    >
                        <i className="bi bi-hospital"></i>FACILITIES
                    </div>

                    <div
                        className={`coldet_tab ${activeTab === "admission" ? "active" : ""}`}
                        onClick={() => setActiveTab("admission")}
                    >
                        <i className="bi bi-clipboard-check"></i>ADMISSION
                    </div>

                    <div
                        className={`coldet_tab ${activeTab === "gallery" ? "active" : ""}`}
                        onClick={() => setActiveTab("gallery")}
                    >
                        <i className="bi bi-image"></i>GALLERY
                    </div>

                    <div
                        className={`coldet_tab ${activeTab === "reviews" ? "active" : ""}`}
                        onClick={() => setActiveTab("reviews")}
                    >
                        <i className="bi bi-chat-dots"></i>REVIEWS
                    </div>
                </div>
            </div>
            <div className="page-body w-100">
                <div className="main-col">

                    {activeTab === "overview" && (
                        <div className="mbapply-cta">
                            <h3>Start Your Application</h3>
                            <p className="mb-2">Free guidance · Zero fees · Expert counsellors ready to help</p>
                            <button className="apply-cta-btn" onClick={() => setOpen(true)}>Apply Now →</button>
                            <button className="contact-btn" onClick={() => setShowAddressPopup(true)}><i className="ti ti-lock-open"></i> Unlock Contact Details</button>
                        </div>
                    )}

                    {activeTab === "overview" && (
                        <div className="sec-card">
                            <div className="sec-head">
                                <div className="sec-head-left">
                                    <div className="sec-icon-wrap"><i className="bi bi-info-circle"></i></div>
                                    <span className="sec-title">Overview</span>
                                </div>
                                <button className="view-btn" onClick={() => setActiveTab("gallery")}
                                ><i className="bi bi-image"></i> View Gallery</button>
                            </div>
                            <div className="sec-body">
                                <div className="overview-grid">
                                    <div
                                        className="overview-text"
                                        dangerouslySetInnerHTML={{
                                            __html: cleanHTML(decodeHTML(collegeDetails?.details || ""))
                                        }}
                                    />
                                    <div className="d-center align-items-start" style={{ borderRadius: "8px" }}>
                                        <img
                                            src={collegeDetails?.college_primary_image}
                                            alt="University"
                                            style={{ borderRadius: "8px", border: "1px solid rgb(0 181 181 / 57%)" }}
                                            className="w-100"
                                        />
                                    </div>
                                </div>
                                <div className="highlights-grid">
                                    <div className="highlight-item"><div className="h-icon"><i className="bi bi-map"></i></div><div><div className="h-label">Campus Area</div><div className="h-val">{collegeDetails?.campus_area} Acres</div></div></div>
                                    <div className="highlight-item"><div className="h-icon"><i className="bi bi-mortarboard"></i></div><div><div className="h-label">Affiliation</div><div className="h-val">{collegeDetails?.university} Univ.</div></div></div>
                                    <div className="highlight-item"><div className="h-icon"><i className="bi bi-patch-check"></i></div><div><div className="h-label">Approval</div><div className="h-val">{collegeDetails?.approved_by} Approved</div></div></div>
                                    <div className="highlight-item"><div className="h-icon"><i className="bi bi-train-front"></i></div><div><div className="h-label">Nearest Railway</div><div className="h-val">{collegeDetails?.city} · {collegeDetails?.near_by_railwaystation}</div></div></div>
                                </div>
                            </div>
                        </div>

                    )}

                    {activeTab === "overview" && collegeCourses.length > 0 && (
                        <div className="sec-card">
                            <div className="sec-head">
                                <div className="sec-head-left">
                                    <div className="sec-icon-wrap"><i className="bi bi-book"></i></div>
                                    <span className="sec-title">Courses Offered</span>
                                    <span className="sec-badge">{collegeCourses.length || 0} Programmes</span>
                                </div>
                                <button className="view-btn" onClick={() => setActiveTab('courses')}  ><i className="bi bi-box-arrow-up-right"></i> View All</button>
                            </div>
                            <div className="sec-body">
                                <div className="course-cards">
                                    {collegeCourses && (collegeCourses.map((course, index) => (
                                        <div className="course-card" key={index}>
                                            <div className="course-info"><div className="course-dot"></div><div><div className="course-name">{course}</div></div>
                                            </div>
                                            <i className="bi bi-chevron-right course-arrow"></i>
                                        </div>
                                    )))}
                                </div>
                            </div>
                        </div>
                    )}

                    {(facilities_data && facilities_data.length > 0 && (activeTab === "overview" || activeTab === "facilities")) && (
                        <div className="sec-card">
                            {activeTab !== "facilities" && (
                                <div className="sec-head">
                                    <div className="sec-head-left">
                                        <div className="sec-icon-wrap"><i className="bi bi-hospital"></i></div>
                                        <span className="sec-title">Facilities</span>
                                        <span className="sec-badge">{facilities_data.length} Available</span>
                                    </div>
                                    <button className="view-btn" onClick={() => setActiveTab('facilities')}><i className="bi bi-box-arrow-up-right"></i> View All</button>
                                </div>
                            )}

                            <div className="sec-body">
                                <div className="fac-grid">
                                    {facilities_data && (facilities_data?.map((facility, index) => (
                                        <div className="fac-card" key={index}>
                                            <div className="fac-icon">
                                                <img src={currentUrl + facility?.path} alt={facility?.name} className="w-100" />
                                            </div>
                                            <div className="fac-label">{facility?.name}</div>
                                        </div>
                                    )))}
                                </div>
                            </div>
                        </div>
                    )}

                    {(activeTab === "overview" || activeTab === "admission") && recruiters.length > 0 && (
                        <div className="sec-card">
                            <div className="sec-head">
                                <div className="sec-head-left">
                                    <div className="sec-icon-wrap"><i className="bi bi-briefcase"></i></div>
                                    <span className="sec-title">Placement Services</span>
                                </div>
                            </div>
                            <div className="sec-body">
                                {/* <div className="placement-stats">
                                    <div className="pl-stat"><div className="pl-num">85%</div><div className="pl-label">Placement Rate</div></div>
                                    <div className="pl-stat"><div className="pl-num">₹6.2L</div><div className="pl-label">Avg. Package</div></div>
                                    <div className="pl-stat"><div className="pl-num">₹18L</div><div className="pl-label">Highest Package</div></div>
                                </div> */}
                                <div className="recheadname-st">Top Recruiters</div>
                                <div className="recruiter-grid">
                                    {recruiters && (recruiters.map((company, index) => (
                                        <div className="rec-card" key={index}>
                                            <img src={company?.rec_image} className="imgrecad-st" alt={company?.rec_tag_name} />
                                            <p className="recimgname-st">{company?.rec_tag_name}</p>
                                        </div>
                                    )))}
                                </div>

                                <div
                                    className="overview-text mt-3"
                                    dangerouslySetInnerHTML={{
                                        __html: cleanHTML(decodeHTML(collegeNewData?.placement_services || ""))
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    {reviewsDetails.length > 0 && (activeTab === "overview" || activeTab === "reviews") && (
                        <div className="sec-card">
                            <div className="sec-head">
                                <div className="sec-head-left">
                                    <div className="sec-icon-wrap"><i className="bi bi-star"></i></div>
                                    <span className="sec-title">College Reviews</span>
                                    <span className="sec-badge">{reviewsDetails.length} Reviews</span>
                                </div>
                                <button className="view-btn" onClick={() => setActiveTab("reviews")}><i className="bi bi-box-arrow-up-right"></i> All Reviews</button>
                            </div>
                            <div className="sec-body">
                                <div className="review-summary">
                                    <div className="big-rating">
                                        <div className="big-num">{collegeDetails.college_ranking}</div>
                                        <div className="big-stars">{renderStars(collegeDetails.college_ranking)}</div>
                                        <div className="big-count">{reviewsDetails.length || 0} reviews</div>
                                    </div>
                                    <div className="rating-bars">
                                        <div className="rbar-row"><span className="rbar-label">5</span><div className="rbar-track"><div className="rbar-fill" style={{ width: "55%" }}></div></div><span className="rbar-count">5</span></div>
                                        <div className="rbar-row"><span className="rbar-label">4</span><div className="rbar-track"><div className="rbar-fill" style={{ width: "33%" }}></div></div><span className="rbar-count">3</span></div>
                                        <div className="rbar-row"><span className="rbar-label">3</span><div className="rbar-track"><div className="rbar-fill" style={{ width: "11%" }}></div></div><span className="rbar-count">1</span></div>
                                        <div className="rbar-row"><span className="rbar-label">2</span><div className="rbar-track"><div className="rbar-fill" style={{ width: "0%" }}></div></div><span className="rbar-count">0</span></div>
                                        <div className="rbar-row"><span className="rbar-label">1</span><div className="rbar-track"><div className="rbar-fill" style={{ width: "0%" }}></div></div><span className="rbar-count">0</span></div>
                                    </div>
                                </div>
                                <div className="review-list">
                                    {reviewsDetails && (reviewsDetails.map((review, index) => (
                                        <div className="review-card" key={index}>
                                            <div className="rev-top"><div className="rev-avatar" style={{ "--ac": "#00B5B5" }}>{getInitials(review?.name)}</div>
                                                <div>
                                                    <div className="rev-name">{review.name}</div>
                                                    <div className="rev-sub">
                                                        <span className="rev-label">{review.review}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="rev-text">
                                                <div
                                                    className="p-desccollege-strv"
                                                    dangerouslySetInnerHTML={{
                                                        __html: cleanHTML(decodeHTML(review.description || ""))
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="side-col">
                    {activeTab === "overview" && (
                        <div className="apply-cta">
                            <h3>Start Your Application</h3>
                            <p className="mb-2">Free guidance · Zero fees · Expert counsellors ready to help</p>
                            <button className="apply-cta-btn" onClick={() => setOpen(true)}>Apply Now →</button>
                            <button className="contact-btn" onClick={() => setShowAddressPopup(true)}><i className="ti ti-lock-open"></i> Unlock Contact Details</button>
                        </div>
                    )}



                    {activeTab === "overview" && (
                        <div className="side-card">
                            <div className="side-head"><i className="bi bi-info-circle"></i> Key Information</div>
                            <div className="side-body">
                                <div className="key-info">
                                    <div className="ki-row"><div className="ki-icon"><i className="bi bi-calendar"></i></div><div><div className="ki-label">Established</div><div className="ki-val">{collegeDetails?.established}</div></div></div>
                                    <div className="ki-row"><div className="ki-icon"><i className="bi bi-mortarboard"></i></div><div><div className="ki-label">University</div><div className="ki-val">{collegeDetails?.university}</div></div></div>
                                    <div className="ki-row"><div className="ki-icon"><i className="bi bi-patch-check"></i></div><div><div className="ki-label">Accreditation</div><div className="ki-val">{collegeDetails?.approved_by} Approved</div></div></div>
                                    <div className="ki-row"><div className="ki-icon"><i className="bi bi-map"></i></div><div><div className="ki-label">Campus Size</div><div className="ki-val">{collegeDetails?.campus_area} Acres</div></div></div>
                                </div>
                            </div>
                        </div>
                    )}


                    {activeTab === "overview" && (
                        <div className="side-card">
                            <div className="side-head"><i className="ti ti-users"></i> Top Faculty</div>
                            <div className="side-body">
                                <div className="faculty-card">
                                    {facultyDetails && (facultyDetails.map((faculty, index) => (
                                        <div key={index} className="d-flex gap-2" >
                                            <div className="fac-av p-2">
                                                <SvgContent svg_name="img_null" stroke="#207d7d" height="52" width="52" />
                                            </div>
                                            <div>
                                                <div className="fac-name">{faculty.top_faculty_name}</div>
                                                <div className="fac-role">{faculty.top_faculty_designation}</div>
                                            </div>
                                        </div>
                                    )))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>



            {activeTab === "courses" && (
                <div className="detcol_table">

                    <div className="detcol_row detcol_header">
                        <div>Course</div>
                        <div>Branch</div>
                        <div></div>
                    </div>

                    {coursesData && (coursesData.map((item, index) => (
                        <div className="detcol_row" key={index}>

                            <div className="detcol_course">
                                {item?.courses}
                            </div>

                            <div className="detcol_branch">
                                {item?.branches?.split(",").length > 0 ? (
                                    item?.branches?.split(",").map((branch, i) => (
                                        <p key={i}>{branch}</p>
                                    ))
                                ) : (
                                    <p>No Branch Available</p>
                                )}
                            </div>

                            <div>
                                <button className="btn-primary" onClick={() => setOpen(true)}>
                                    Apply Now
                                </button>
                            </div>

                        </div>
                    )))}

                </div>
            )}

            {(eligibilityAd.length > 0 && (activeTab === "overview" || activeTab === "admission")) && (
                <div className="coldet_section">
                    {activeTab !== "admission" && (
                        <div className="coldet_section_header">
                            <h5 className="fw-bold mb-0">ELIGIBILITY & ADMISSION PROCEDURE</h5>
                            <button className="coldet_view_btn" onClick={() => setActiveTab('admission')}>View Details</button>
                        </div>
                    )}

                    <div className="coldet_faculty_grid d-flex gap-5">
                        <div>
                            <h5 style={{ color: "#2966a3" }}>Minimum Eligibility</h5>
                            {eligibilityAd && eligibilityAd.map((item, idx) => (
                                <p key={idx} className="text-center">{item.min_elg}</p>
                            ))}
                        </div>

                        <div>
                            <h5 style={{ color: "#2966a3" }}>Exams Accepted</h5>
                            {eligibilityAd && eligibilityAd.map((item, idx) => (
                                <p key={idx} className="text-center">{item.name}</p>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {
                (picGallery.length > 0 && activeTab === "gallery") && (
                    <div className="coldet_section mb-5">
                        {activeTab !== "gallery" && (
                            <div className="coldet_section_header">
                                <h3>LIFE AT THE CAMPUS</h3>
                                <button className="coldet_view_btn" onClick={() => setActiveTab("gallery")}>View All</button>
                            </div>
                        )}

                        <div className="coldet_campus_gallery">
                            {picGallery && picGallery.map((img, index) => (
                                <div key={index} className="coldet_gallery_item">
                                    <img src={img.pgallery} alt="Campus" />
                                </div>
                            ))}
                        </div>
                    </div>
                )
            }

            {
                !loading && (
                    <div className="w-100 mt-5">
                        <Footer />
                    </div>
                )
            }


            {open && (
                <ApplyNow data={collegeDetails || ""} onCloseHandler={onCloseHandler} />
            )}

        </div >
    );
};

export default CollegeDetail;